const allData = [
  {
    zip: 94702,
    lead_risk: 75.36,
    toxic_release: 60.75,
    traffic: 49.38,
    cleanup_sites: 89.44,
    groundwater_threats: 93.51,
    hazardous_waste: 63.76,
    impaired_bodies_of_water: 84.2,
    pollution: 69.1,
    asthma: 86.07,
    low_birth_weight: 82.46,
    cardiovascular_disease: 50.59,
    education: 25.56,
    linguistic_isolation: 44.88,
    poverty: 33.47,
    unemployment: 29.9,
    housing_burden: 39.2,
    pop_char_pctl: 56.07,
  },
  {
    zip: 94702,
    lead_risk: 63.05,
    toxic_release: 59.34,
    traffic: 32.56,
    cleanup_sites: 0.0,
    groundwater_threats: 90.73,
    hazardous_waste: 0.0,
    impaired_bodies_of_water: 0.0,
    pollution: 19.49,
    asthma: 23.09,
    low_birth_weight: 83.85,
    cardiovascular_disease: 9.07,
    education: 2.19,
    linguistic_isolation: 17.48,
    poverty: 14.33,
    unemployment: 15.05,
    housing_burden: 41.03,
    pop_char_pctl: 17.7,
  },
  {
    zip: 94702,
    lead_risk: 68.82,
    toxic_release: 71.8,
    traffic: 31.24,
    cleanup_sites: 78.07,
    groundwater_threats: 97.54,
    hazardous_waste: 85.62,
    impaired_bodies_of_water: 90.16,
    pollution: 70.52,
    asthma: 81.09,
    low_birth_weight: 44.47,
    cardiovascular_disease: 46.83,
    education: 35.38,
    linguistic_isolation: 8.54,
    poverty: 47.8,
    unemployment: 56.19,
    housing_burden: 44.76,
    pop_char_pctl: 47.35,
  },
  {
    zip: 94702,
    lead_risk: 61.43,
    toxic_release: 65.67,
    traffic: 41.51,
    cleanup_sites: 45.2,
    groundwater_threats: 94.39,
    hazardous_waste: 59.48,
    impaired_bodies_of_water: 90.16,
    pollution: 54.03,
    asthma: 87.91,
    low_birth_weight: 58.56,
    cardiovascular_disease: 61.42,
    education: 24.29,
    linguistic_isolation: 15.38,
    poverty: 38.43,
    unemployment: 2.59,
    housing_burden: 67.52,
    pop_char_pctl: 49.56,
  },
  {
    zip: 94702,
    lead_risk: 66.78,
    toxic_release: 63.78,
    traffic: 53.93,
    cleanup_sites: 73.39,
    groundwater_threats: 91.65,
    hazardous_waste: 80.95,
    impaired_bodies_of_water: 84.2,
    pollution: 66.46,
    asthma: 87.77,
    low_birth_weight: 54.27,
    cardiovascular_disease: 61.08,
    education: 19.03,
    linguistic_isolation: 23.01,
    poverty: 40.16,
    unemployment: 18.57,
    housing_burden: 70.33,
    pop_char_pctl: 51.63,
  },
  {
    zip: 94703,
    lead_risk: 78.91,
    toxic_release: 61.62,
    traffic: 39.66,
    cleanup_sites: 23.64,
    groundwater_threats: 53.79,
    hazardous_waste: 26.37,
    impaired_bodies_of_water: 84.2,
    pollution: 40.3,
    asthma: 68.51,
    low_birth_weight: 24.08,
    cardiovascular_disease: 30.58,
    education: 25.1,
    linguistic_isolation: 32.23,
    poverty: 50.39,
    unemployment: 48.56,
    housing_burden: 33.24,
    pop_char_pctl: 34.65,
  },
  {
    zip: 94703,
    lead_risk: 68.97,
    toxic_release: 63.33,
    traffic: 3.81,
    cleanup_sites: 27.73,
    groundwater_threats: 51.46,
    hazardous_waste: 16.41,
    impaired_bodies_of_water: 24.15,
    pollution: 14.11,
    asthma: 13.09,
    low_birth_weight: 13.14,
    cardiovascular_disease: 8.49,
    education: 6.26,
    linguistic_isolation: 34.49,
    poverty: 44.03,
    unemployment: 41.23,
    housing_burden: 42.68,
    pop_char_pctl: 10.79,
  },
  {
    zip: 94703,
    lead_risk: 66.94,
    toxic_release: 63.83,
    traffic: 39.4,
    cleanup_sites: 8.76,
    groundwater_threats: 79.44,
    hazardous_waste: 26.37,
    impaired_bodies_of_water: 24.15,
    pollution: 26.75,
    asthma: 71.1,
    low_birth_weight: 1.55,
    cardiovascular_disease: 34.01,
    education: 2.97,
    linguistic_isolation: 17.48,
    poverty: 53.71,
    unemployment: 23.29,
    housing_burden: 75.42,
    pop_char_pctl: 27.59,
  },
  {
    zip: 94703,
    lead_risk: 64.39,
    toxic_release: 61.64,
    traffic: 8.99,
    cleanup_sites: 42.96,
    groundwater_threats: 81.63,
    hazardous_waste: 73.22,
    impaired_bodies_of_water: 13.12,
    pollution: 27.17,
    asthma: 5.63,
    low_birth_weight: 15.87,
    cardiovascular_disease: 4.22,
    education: 22.12,
    linguistic_isolation: 50.05,
    poverty: 70.94,
    unemployment: 52.65,
    housing_burden: 85.62,
    pop_char_pctl: 23.46,
  },
  {
    zip: 94703,
    lead_risk: 44.34,
    toxic_release: 67.92,
    traffic: 90.01,
    cleanup_sites: 47.21,
    groundwater_threats: 93.29,
    hazardous_waste: 91.05,
    impaired_bodies_of_water: 90.16,
    pollution: 81.26,
    asthma: 19.45,
    low_birth_weight: 19.93,
    cardiovascular_disease: 1.81,
    education: 8.21,
    linguistic_isolation: 84.03,
    poverty: 68.81,
    unemployment: 25.84,
    housing_burden: 98.72,
    pop_char_pctl: 28.02,
  },
  {
    zip: 94703,
    lead_risk: 52.26,
    toxic_release: 59.51,
    traffic: 0.03,
    cleanup_sites: 31.14,
    groundwater_threats: 74.67,
    hazardous_waste: 79.22,
    impaired_bodies_of_water: 13.12,
    pollution: 19.18,
    asthma: 1.55,
    low_birth_weight: 75.12,
    cardiovascular_disease: 10.12,
    education: 1.62,
    linguistic_isolation: 5.81,
    poverty: 95.5,
    unemployment: 79.69,
    housing_burden: 98.79,
    pop_char_pctl: 39.23,
  },
  {
    zip: 94703,
    lead_risk: 22.77,
    toxic_release: 61.74,
    traffic: 12.33,
    cleanup_sites: 20.5,
    groundwater_threats: 79.48,
    hazardous_waste: 60.26,
    impaired_bodies_of_water: 0.0,
    pollution: 16.27,
    asthma: 5.5,
    low_birth_weight: 90.16,
    cardiovascular_disease: 29.65,
    education: 23.81,
    linguistic_isolation: 58.59,
    poverty: 93.04,
    unemployment: 9.23,
    housing_burden: 99.53,
    pop_char_pctl: 49.29,
  },
  {
    zip: 94704,
    lead_risk: 62.49,
    toxic_release: 58.04,
    traffic: 40.56,
    cleanup_sites: 0.0,
    groundwater_threats: 83.36,
    hazardous_waste: 0.0,
    impaired_bodies_of_water: 0.0,
    pollution: 18.2,
    asthma: 28.04,
    low_birth_weight: 6.79,
    cardiovascular_disease: 12.99,
    education: 0.37,
    linguistic_isolation: 18.31,
    poverty: 6.68,
    unemployment: 11.93,
    housing_burden: 19.19,
    pop_char_pctl: 2.79,
  },
  {
    zip: 94704,
    lead_risk: 64.59,
    toxic_release: 60.1,
    traffic: 60.13,
    cleanup_sites: 52.96,
    groundwater_threats: 81.17,
    hazardous_waste: 43.58,
    impaired_bodies_of_water: 0.0,
    pollution: 39.24,
    asthma: 43.89,
    low_birth_weight: 59.19,
    cardiovascular_disease: 10.52,
    education: 2.19,
    linguistic_isolation: 10.45,
    poverty: 35.95,
    unemployment: 50.06,
    housing_burden: 63.33,
    pop_char_pctl: 27.65,
  },
  {
    zip: 94704,
    lead_risk: 59.29,
    toxic_release: 62.76,
    traffic: 46.79,
    cleanup_sites: 19.43,
    groundwater_threats: 78.95,
    hazardous_waste: 30.23,
    impaired_bodies_of_water: 84.2,
    pollution: 38.22,
    asthma: 75.67,
    low_birth_weight: 65.36,
    cardiovascular_disease: 40.42,
    education: 2.58,
    linguistic_isolation: 'NA',
    poverty: 32.89,
    unemployment: 20.89,
    housing_burden: 73.27,
    pop_char_pctl: 44.82,
  },
  {
    zip: 94704,
    lead_risk: 48.82,
    toxic_release: 60.32,
    traffic: 5.65,
    cleanup_sites: 10.98,
    groundwater_threats: 54.31,
    hazardous_waste: 56.03,
    impaired_bodies_of_water: 13.12,
    pollution: 21.38,
    asthma: 5.35,
    low_birth_weight: 17.68,
    cardiovascular_disease: 26.15,
    education: 15.74,
    linguistic_isolation: 33.01,
    poverty: 93.42,
    unemployment: 37.78,
    housing_burden: 99.39,
    pop_char_pctl: 29.27,
  },
  {
    zip: 94704,
    lead_risk: 55.58,
    toxic_release: 60.35,
    traffic: 2.28,
    cleanup_sites: 36.17,
    groundwater_threats: 71.16,
    hazardous_waste: 65.21,
    impaired_bodies_of_water: 13.12,
    pollution: 30.67,
    asthma: 1.42,
    low_birth_weight: 'NA',
    cardiovascular_disease: 9.57,
    education: 17.34,
    linguistic_isolation: 16.42,
    poverty: 99.02,
    unemployment: 90.39,
    housing_burden: 99.67,
    pop_char_pctl: 27.54,
  },
  {
    zip: 94705,
    lead_risk: 7.49,
    toxic_release: 58.1,
    traffic: 55.94,
    cleanup_sites: 60.78,
    groundwater_threats: 52.6,
    hazardous_waste: 96.85,
    impaired_bodies_of_water: 24.15,
    pollution: 32.27,
    asthma: 4.44,
    low_birth_weight: 23.06,
    cardiovascular_disease: 1.42,
    education: 7.63,
    linguistic_isolation: 11.19,
    poverty: 9.22,
    unemployment: 'NA',
    housing_burden: 12.91,
    pop_char_pctl: 1.08,
  },
  {
    zip: 94705,
    lead_risk: 65.41,
    toxic_release: 64.28,
    traffic: 7.7,
    cleanup_sites: 8.76,
    groundwater_threats: 50.18,
    hazardous_waste: 8.74,
    impaired_bodies_of_water: 24.15,
    pollution: 10.93,
    asthma: 65.65,
    low_birth_weight: 0.0,
    cardiovascular_disease: 28.98,
    education: 7.63,
    linguistic_isolation: 0.87,
    poverty: 14.05,
    unemployment: 46.14,
    housing_burden: 17.04,
    pop_char_pctl: 12.72,
  },
  {
    zip: 94705,
    lead_risk: 72.77,
    toxic_release: 59.63,
    traffic: 36.54,
    cleanup_sites: 0.0,
    groundwater_threats: 75.22,
    hazardous_waste: 16.41,
    impaired_bodies_of_water: 0.0,
    pollution: 22.43,
    asthma: 17.82,
    low_birth_weight: 49.62,
    cardiovascular_disease: 7.22,
    education: 2.97,
    linguistic_isolation: 7.56,
    poverty: 39.1,
    unemployment: 29.9,
    housing_burden: 57.15,
    pop_char_pctl: 14.91,
  },
  {
    zip: 94705,
    lead_risk: 78.13,
    toxic_release: 60.77,
    traffic: 28.83,
    cleanup_sites: 10.98,
    groundwater_threats: 58.41,
    hazardous_waste: 48.0,
    impaired_bodies_of_water: 0.0,
    pollution: 25.05,
    asthma: 38.47,
    low_birth_weight: 2.14,
    cardiovascular_disease: 28.98,
    education: 17.34,
    linguistic_isolation: 11.96,
    poverty: 66.75,
    unemployment: 61.36,
    housing_burden: 78.13,
    pop_char_pctl: 27.72,
  },
  {
    zip: 94707,
    lead_risk: 57.91,
    toxic_release: 62.88,
    traffic: 1.98,
    cleanup_sites: 0.0,
    groundwater_threats: 10.46,
    hazardous_waste: 0.0,
    impaired_bodies_of_water: 13.12,
    pollution: 1.36,
    asthma: 5.26,
    low_birth_weight: 78.65,
    cardiovascular_disease: 2.65,
    education: 3.73,
    linguistic_isolation: 5.81,
    poverty: 6.48,
    unemployment: 12.85,
    housing_burden: 2.34,
    pop_char_pctl: 5.59,
  },
  {
    zip: 94707,
    lead_risk: 67.69,
    toxic_release: 65.1,
    traffic: 3.03,
    cleanup_sites: 0.0,
    groundwater_threats: 10.84,
    hazardous_waste: 50.18,
    impaired_bodies_of_water: 34.11,
    pollution: 8.94,
    asthma: 7.69,
    low_birth_weight: 40.66,
    cardiovascular_disease: 5.67,
    education: 2.58,
    linguistic_isolation: 13.56,
    poverty: 1.37,
    unemployment: 12.85,
    housing_burden: 7.39,
    pop_char_pctl: 2.35,
  },
  {
    zip: 94707,
    lead_risk: 60.92,
    toxic_release: 64.39,
    traffic: 1.74,
    cleanup_sites: 0.0,
    groundwater_threats: 0.0,
    hazardous_waste: 8.74,
    impaired_bodies_of_water: 24.15,
    pollution: 2.66,
    asthma: 6.23,
    low_birth_weight: 30.59,
    cardiovascular_disease: 4.17,
    education: 4.11,
    linguistic_isolation: 4.09,
    poverty: 0.63,
    unemployment: 48.56,
    housing_burden: 7.73,
    pop_char_pctl: 2.69,
  },
  {
    zip: 94708,
    lead_risk: 65.42,
    toxic_release: 65.29,
    traffic: 7.44,
    cleanup_sites: 0.0,
    groundwater_threats: 32.93,
    hazardous_waste: 41.46,
    impaired_bodies_of_water: 90.16,
    pollution: 18.9,
    asthma: 11.07,
    low_birth_weight: 24.31,
    cardiovascular_disease: 6.54,
    education: 5.35,
    linguistic_isolation: 0.0,
    poverty: 3.2,
    unemployment: 8.26,
    housing_burden: 8.3,
    pop_char_pctl: 0.91,
  },
  {
    zip: 94708,
    lead_risk: 60.76,
    toxic_release: 61.7,
    traffic: 2.63,
    cleanup_sites: 31.01,
    groundwater_threats: 41.88,
    hazardous_waste: 87.62,
    impaired_bodies_of_water: 24.15,
    pollution: 15.66,
    asthma: 3.54,
    low_birth_weight: 1.01,
    cardiovascular_disease: 1.33,
    education: 0.61,
    linguistic_isolation: 2.95,
    poverty: 12.05,
    unemployment: 25.84,
    housing_burden: 12.91,
    pop_char_pctl: 0.21,
  },
  {
    zip: 94708,
    lead_risk: 65.36,
    toxic_release: 63.87,
    traffic: 1.66,
    cleanup_sites: 3.12,
    groundwater_threats: 25.13,
    hazardous_waste: 0.0,
    impaired_bodies_of_water: 24.15,
    pollution: 4.39,
    asthma: 3.4,
    low_birth_weight: 74.52,
    cardiovascular_disease: 1.0,
    education: 14.61,
    linguistic_isolation: 'NA',
    poverty: 13.38,
    unemployment: 31.32,
    housing_burden: 15.72,
    pop_char_pctl: 10.66,
  },
  {
    zip: 94709,
    lead_risk: 74.69,
    toxic_release: 66.9,
    traffic: 25.26,
    cleanup_sites: 28.09,
    groundwater_threats: 93.49,
    hazardous_waste: 70.25,
    impaired_bodies_of_water: 90.16,
    pollution: 54.59,
    asthma: 61.02,
    low_birth_weight: 10.41,
    cardiovascular_disease: 23.19,
    education: 9.17,
    linguistic_isolation: 35.12,
    poverty: 22.91,
    unemployment: 60.24,
    housing_burden: 5.11,
    pop_char_pctl: 18.58,
  },
  {
    zip: 94709,
    lead_risk: 73.91,
    toxic_release: 59.0,
    traffic: 16.73,
    cleanup_sites: 10.98,
    groundwater_threats: 61.92,
    hazardous_waste: 28.51,
    impaired_bodies_of_water: 13.12,
    pollution: 17.25,
    asthma: 9.82,
    low_birth_weight: 7.66,
    cardiovascular_disease: 9.53,
    education: 0.0,
    linguistic_isolation: 1.98,
    poverty: 73.47,
    unemployment: 27.44,
    housing_burden: 64.67,
    pop_char_pctl: 9.33,
  },
  {
    zip: 94709,
    lead_risk: 40.26,
    toxic_release: 62.68,
    traffic: 16.1,
    cleanup_sites: 36.92,
    groundwater_threats: 79.37,
    hazardous_waste: 56.03,
    impaired_bodies_of_water: 24.15,
    pollution: 28.44,
    asthma: 10.9,
    low_birth_weight: 10.94,
    cardiovascular_disease: 10.63,
    education: 1.23,
    linguistic_isolation: 56.3,
    poverty: 65.95,
    unemployment: 36.44,
    housing_burden: 91.31,
    pop_char_pctl: 20.81,
  },
  {
    zip: 94710,
    lead_risk: 62.6,
    toxic_release: 66.12,
    traffic: 94.18,
    cleanup_sites: 97.1,
    groundwater_threats: 99.77,
    hazardous_waste: 98.83,
    impaired_bodies_of_water: 90.16,
    pollution: 93.68,
    asthma: 72.77,
    low_birth_weight: 43.08,
    cardiovascular_disease: 34.18,
    education: 34.69,
    linguistic_isolation: 10.45,
    poverty: 49.79,
    unemployment: 75.06,
    housing_burden: 50.05,
    pop_char_pctl: 45.79,
  },
  {
    zip: 94710,
    lead_risk: 76.99,
    toxic_release: 62.07,
    traffic: 52.25,
    cleanup_sites: 86.39,
    groundwater_threats: 93.17,
    hazardous_waste: 81.02,
    impaired_bodies_of_water: 84.2,
    pollution: 73.55,
    asthma: 87.38,
    low_birth_weight: 5.03,
    cardiovascular_disease: 59.93,
    education: 35.05,
    linguistic_isolation: 20.87,
    poverty: 48.27,
    unemployment: 84.55,
    housing_burden: 73.93,
    pop_char_pctl: 52.7,
  },
  {
    zip: 94710,
    lead_risk: 81.02,
    toxic_release: 60.3,
    traffic: 58.21,
    cleanup_sites: 62.66,
    groundwater_threats: 71.23,
    hazardous_waste: 50.18,
    impaired_bodies_of_water: 84.2,
    pollution: 58.18,
    asthma: 63.55,
    low_birth_weight: 25.66,
    cardiovascular_disease: 19.07,
    education: 39.87,
    linguistic_isolation: 30.83,
    poverty: 63.47,
    unemployment: 27.44,
    housing_burden: 84.18,
    pop_char_pctl: 39.24,
  },
  {
    zip: 94710,
    lead_risk: 71.07,
    toxic_release: 64.42,
    traffic: 41.44,
    cleanup_sites: 81.12,
    groundwater_threats: 94.78,
    hazardous_waste: 90.98,
    impaired_bodies_of_water: 84.2,
    pollution: 73.02,
    asthma: 81.09,
    low_birth_weight: 72.85,
    cardiovascular_disease: 46.83,
    education: 44.01,
    linguistic_isolation: 'NA',
    poverty: 66.48,
    unemployment: 73.8,
    housing_burden: 89.7,
    pop_char_pctl: 76.58,
  },
  {
    zip: 94720,
    lead_risk: 'NA',
    toxic_release: 60.68,
    traffic: 4.8,
    cleanup_sites: 50.69,
    groundwater_threats: 92.1,
    hazardous_waste: 94.66,
    impaired_bodies_of_water: 13.12,
    pollution: 33.84,
    asthma: 1.46,
    low_birth_weight: 'NA',
    cardiovascular_disease: 14.94,
    education: 'NA',
    linguistic_isolation: 'NA',
    poverty: 'NA',
    unemployment: 'NA',
    housing_burden: 'NA',
    pop_char_pctl: 'NA',
  },
];

export default allData;
